(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[768,6566],{

/***/ 16776:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/Product-Image-Coming-Soon.f5fa4d74.png","height":500,"width":500,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAElBMVEX////s7Ozi4uLS0tLx8fH29vak7Od+AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAJUlEQVR4nG3GuQ0AAAjDwHzsvzJSSsQ1NvAYezqx05IRAVBS51oIFgA2WcXaawAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 94157:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/choose.7ee3671a.svg","height":683,"width":683});

/***/ }),

/***/ 37507:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/hot-cup.d3dc6dca.svg","height":464,"width":464});

/***/ }),

/***/ 93755:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/location.9955f1a7.svg","height":512,"width":512});

/***/ }),

/***/ 22396:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/affirm-dark.99e1094d.png","height":36,"width":90,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAALVBMVEUAMDAAGyoPr/sAFSIADxgAFyQPsv8LerMABAgAIjUAGioSqvUAChIISm0HRmb/Qar+AAAAD3RSTlMCYjhzL5pPgD13hRt+e0i270SIAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAI0lEQVR4nGNgYGDgZmNiY2JgYWTl5WPhYGdg5WJkZubkYQcABgYAhr+eOjQAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 16379:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/video-thumbnail.62c3259c.png","height":572,"width":1000,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAATlBMVEUAAAC6yMmqvMGJpLF7hoWAi5KSpa24y9NDPzqTkoF+i5I5NDQAAACHlp9ISEOXo5+errZ1lqGcpZSXtcR8l6NZV1Vbd4GqrKxTU0zl/f8Ne/DgAAAADXRSTlMh/v7+7+3v7/D27TUeBrGDUQAAAAlwSFlzAAALEwAACxMBAJqcGAAAADBJREFUeJwFwYUBACAMA7DiuuH2/6MkMJWIasxwo031HGC3OLJpQJfQSw+AX3yZffopfwHag6ISHAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 63928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26626);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);









var CategoryBreadcrumb = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(CategoryBreadcrumb, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(CategoryBreadcrumb);
    function CategoryBreadcrumb() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, CategoryBreadcrumb);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(CategoryBreadcrumb, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, category = _props.category, breadcrumbs = _props.breadcrumbs;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "breadcrumb-section",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-sm-6",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "page-title",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            children: category.name
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-sm-12 col-md-12 col-lg-6",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                                        "aria-label": "breadcrumb",
                                        className: "theme-breadcrumb",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ol", {
                                            className: "breadcrumb",
                                            children: breadcrumbs ? breadcrumbs.map(function(item, i) {
                                                var url = "";
                                                for(var j = 1; j <= i; j++){
                                                    var valueToInject = breadcrumbs[j].name === "Hybrid or Electric" ? "hybrid-electric" : breadcrumbs[j].name;
                                                    url += valueToInject.replace(/\./g, "-").toLowerCase() + "-";
                                                }
                                                url = url.replace(/\s/g, "-").slice(0, -1);
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    className: "breadcrumb-item",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                        href: item.id == 0 ? "/" : "/category/[category]",
                                                        as: item.id == 0 ? "/" : "/category/".concat(url),
                                                        prefetch: false,
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                            children: item.name
                                                        })
                                                    })
                                                }, i);
                                            }) : category.name
                                        })
                                    })
                                })
                            ]
                        })
                    })
                });
            }
        }
    ]);
    return CategoryBreadcrumb;
}(react__WEBPACK_IMPORTED_MODULE_2__.Component);
(0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(CategoryBreadcrumb, "propTypes", {
    category: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().object),
    breadcrumbs: (prop_types__WEBPACK_IMPORTED_MODULE_8___default().array)
});
/* harmony default export */ __webpack_exports__["Z"] = (CategoryBreadcrumb);


/***/ }),

/***/ 89075:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(51438);
/* harmony import */ var _swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(52951);
/* harmony import */ var _swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(88029);
/* harmony import */ var _swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26626);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);







var Breadcrumb = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_swc_helpers_src_inherits_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(Breadcrumb, Component);
    var _super = (0,_swc_helpers_src_create_super_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(Breadcrumb);
    function Breadcrumb() {
        (0,_swc_helpers_src_class_call_check_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)(this, Breadcrumb);
        return _super.apply(this, arguments);
    }
    (0,_swc_helpers_src_create_class_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(Breadcrumb, [
        {
            key: "render",
            value: function render() {
                var title = this.props.title;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "breadcrumb-section",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "container",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "row align-items-center",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-md-6",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "page-title",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                            children: title
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-md-6",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("nav", {
                                        "aria-label": "breadcrumb",
                                        className: "theme-breadcrumb",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("ol", {
                                            className: "breadcrumb",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                    href: "/",
                                                    as: "/",
                                                    passHref: true,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                        className: "breadcrumb-item",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_1___default()), {
                                                            href: "/",
                                                            children: "Home"
                                                        })
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("li", {
                                                    className: "breadcrumb-item active",
                                                    "aria-current": "page",
                                                    children: title
                                                })
                                            ]
                                        })
                                    })
                                })
                            ]
                        })
                    })
                });
            }
        }
    ]);
    return Breadcrumb;
}(react__WEBPACK_IMPORTED_MODULE_2__.Component);
/* harmony default export */ __webpack_exports__["Z"] = (Breadcrumb);


/***/ }),

/***/ 76566:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_responsive_modal__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(31190);
/* harmony import */ var react_youtube__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(5406);




var opts = {
    height: "390",
    width: "640",
    playerVars: {
        autoplay: 1,
        rel: 0
    }
};
var VideoModal = function(param) {
    var open = param.open, onCloseModal = param.onCloseModal;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_responsive_modal__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        classNames: {
            modal: "video-modal",
            closeButton: "close-btn"
        },
        open: open,
        onClose: function() {
            return onCloseModal();
        },
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "inner",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_youtube__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                videoId: "kmCc2zfZVzU",
                opts: opts
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (VideoModal);


/***/ }),

/***/ 74673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ product; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs + 1 modules
var _inherits = __webpack_require__(88029);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 3 modules
var _create_super = __webpack_require__(26626);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/static/images/icon/landing/choose.svg
var choose = __webpack_require__(94157);
// EXTERNAL MODULE: ./src/static/images/icon/landing/hot-cup.svg
var hot_cup = __webpack_require__(37507);
// EXTERNAL MODULE: ./src/static/images/icon/landing/location.svg
var landing_location = __webpack_require__(93755);
// EXTERNAL MODULE: ./src/static/images/video-thumbnail.png
var video_thumbnail = __webpack_require__(16379);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/category/Bio/index.jsx
var Bio = __webpack_require__(18016);
// EXTERNAL MODULE: ./src/components/category/CategoryBreadCrumb/index.jsx
var CategoryBreadCrumb = __webpack_require__(63928);
// EXTERNAL MODULE: ./src/components/category/Reviews/index.jsx + 2 modules
var Reviews = __webpack_require__(61874);
// EXTERNAL MODULE: ./src/components/home/breadcrumb.jsx
var breadcrumb = __webpack_require__(89075);
// EXTERNAL MODULE: ./src/components/modals/FeedbackModal.jsx
var FeedbackModal = __webpack_require__(40456);
// EXTERNAL MODULE: ./src/components/modals/VideoModal.jsx
var VideoModal = __webpack_require__(76566);
// EXTERNAL MODULE: ./src/components/product/CampaignBanner.jsx + 3 modules
var CampaignBanner = __webpack_require__(1278);
// EXTERNAL MODULE: ./node_modules/axios/lib/axios.js + 48 modules
var axios = __webpack_require__(87066);
// EXTERNAL MODULE: ./src/functions/getProductServicesArray.js
var getProductServicesArray = __webpack_require__(84933);
// EXTERNAL MODULE: ./src/components/loader.jsx
var loader = __webpack_require__(67407);
// EXTERNAL MODULE: ./src/components/product/AddToCartSelector.jsx + 1 modules
var AddToCartSelector = __webpack_require__(28991);
;// CONCATENATED MODULE: ./src/components/product/HorizontalLoader.jsx


function HorizontalLoader() {
    return /*#__PURE__*/ _jsxs("div", {
        id: "fountainG",
        children: [
            /*#__PURE__*/ _jsx("div", {
                id: "fountainG_1",
                className: "fountainG"
            }),
            /*#__PURE__*/ _jsx("div", {
                id: "fountainG_2",
                className: "fountainG"
            }),
            /*#__PURE__*/ _jsx("div", {
                id: "fountainG_3",
                className: "fountainG"
            }),
            /*#__PURE__*/ _jsx("div", {
                id: "fountainG_4",
                className: "fountainG"
            }),
            /*#__PURE__*/ _jsx("div", {
                id: "fountainG_5",
                className: "fountainG"
            }),
            /*#__PURE__*/ _jsx("div", {
                id: "fountainG_6",
                className: "fountainG"
            }),
            /*#__PURE__*/ _jsx("div", {
                id: "fountainG_7",
                className: "fountainG"
            }),
            /*#__PURE__*/ _jsx("div", {
                id: "fountainG_8",
                className: "fountainG"
            })
        ]
    });
}

// EXTERNAL MODULE: ./src/components/home/PlacesSearch/index.jsx + 2 modules
var PlacesSearch = __webpack_require__(69174);
;// CONCATENATED MODULE: ./src/components/product/NotAvailable.jsx



var NotAvailable = function(props) {
    var isLoading = props.isLoading;
    var geolocation = props.geolocation;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "not-available add-to-cart-selector",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "blured-content"
                }),
                isLoading ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-content checking-availability",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "inner",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "icon-container"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "content-container",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fas fa-info-circle"
                                            }),
                                            " Checking availability..."
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Our products and service availability are dependent on where you are located."
                                    })
                                ]
                            })
                        ]
                    })
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "text-content",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "inner",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "icon-container"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "content-container",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                className: "fas fa-exclamation-triangle"
                                            }),
                                            " ",
                                            geolocation.formatted_address || geolocation.formattedAddress ? "Not available" : "Location Required"
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: "Our products and service availability are dependent on where you are located."
                                    }),
                                    geolocation.formatted_address || geolocation.formattedAddress ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                        className: "mt-2",
                                        children: [
                                            "This product is not available for your current location",
                                            " ",
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                children: geolocation.formatted_address || geolocation.formattedAddress
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                className: "btn book",
                                                href: "/category/".concat(props.categoryUrlSlug),
                                                children: "See Available Products"
                                            })
                                        ]
                                    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(PlacesSearch/* default */.Z, {
                                        isModalOpen: false,
                                        hasMyLocationButton: true
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var product_NotAvailable = (NotAvailable);

// EXTERNAL MODULE: ./src/components/product/ProviderDetails.jsx
var ProviderDetails = __webpack_require__(83922);
// EXTERNAL MODULE: ./node_modules/react-star-ratings/build/index.js
var build = __webpack_require__(39503);
// EXTERNAL MODULE: ./src/static/images/logos/affirm-dark.png
var affirm_dark = __webpack_require__(22396);
;// CONCATENATED MODULE: ./src/components/product/UpsellOverlay.jsx






var UpsellOverlay_NotAvailable = function(props) {
    var isLoading = props.isLoading, urlSlug = props.urlSlug;
    var geolocation = props.geolocation;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "upsell-overlay sidebar active",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "inner-outside",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "inner",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h3", {
                            children: [
                                "Mobile Car & Truck Battery Replacement Service in",
                                " ",
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    children: "".concat(geolocation && geolocation.formatted_address ? geolocation.formatted_address : "Your City")
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "body",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fas fa-check"
                                                }),
                                                " Book Online for ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                    children: "Immediate Delivery"
                                                }),
                                                " or ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                                                    children: "Make Appointment"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fas fa-check"
                                                }),
                                                " Installation Included in Price - No Hidden Charges!"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fas fa-check"
                                                }),
                                                " Our JumpStart Guarantee!"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fas fa-check"
                                                }),
                                                " Professional Technicans with Real Time Tracking!"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "fas fa-check"
                                                }),
                                                " Buy now, pay over time with",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    src: affirm_dark/* default.src */.Z.src,
                                                    alt: "Car Battery Installation Video",
                                                    className: "lazyload"
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "btn-container",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        href: "/category/".concat(urlSlug),
                                        className: "btn book",
                                        children: "Schedule Online"
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "footer mt-2",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews["default"], {
                                type: "minimal"
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var UpsellOverlay = (UpsellOverlay_NotAvailable);

;// CONCATENATED MODULE: ./src/components/product/details-price.jsx








var formatCurrency = __webpack_require__(9180);








var DetailsWithPrice = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(DetailsWithPrice, Component);
    var _super = (0,_create_super/* default */.Z)(DetailsWithPrice);
    function DetailsWithPrice(props) {
        (0,_class_call_check/* default */.Z)(this, DetailsWithPrice);
        var _this;
        _this = _super.call(this, props);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "getProviderDetails", function() {
            if (!_this.props.item || !_this.props.item.isAvailable || !_this.props.geolocation || !_this.props.item.selectedProviderService) {
                return null;
            }
            var _geolocation = _this.props.geolocation, latitude = _geolocation.latitude, longitude = _geolocation.longitude;
            var ProviderId = _this.props.item.selectedProviderService.providerId.ProviderId;
            if (ProviderId && latitude != undefined) {
                var _this1 = (0,_assert_this_initialized/* default */.Z)(_this);
                var url = "https://api.marketring-api.com/v1/providerlocations/".concat(ProviderId, "?GoogleData=true&lat=").concat(latitude, "&lng=").concat(longitude); // Call from Cache..
                var result = axios/* default.get */.Z.get(url, {
                    crossdomain: true
                }).then(function(response) {
                    _this1.setState({
                        providerDetails: response.data,
                        showProviderDetails: true
                    });
                }).catch(function(error) {
                    return null;
                });
                return result;
            } else {
                return null;
            }
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "onOpenModal", function() {
            _this.setState({
                open: true
            });
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "onCloseModal", function() {
            _this.setState({
                open: false
            });
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "minusQty", function() {
            if (_this.state.quantity > 1) {
                _this.setState({
                    stock: "In Stock"
                });
                _this.setState({
                    quantity: _this.state.quantity - 1
                });
            }
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "plusQty", function() {
            _this.setState({
                quantity: _this.state.quantity + 1
            });
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "changeQty", function(e) {
            _this.setState({
                quantity: parseInt(e.target.value)
            });
        });
        // Hack for forcing state to re-render when provider changed.
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "forceState", function() {
            _this.setState({
                forceState: !_this.state.forceState
            });
        });
        _this.productBox = /*#__PURE__*/ react.createRef();
        _this.state = {
            showProviderDetails: false,
            productBoxWidth: 0,
            productBoxHeight: 0,
            open: false,
            quantity: 1,
            stock: "InStock",
            integratedLocationsHeight: null,
            forceState: false
        };
        _this.getProviderDetails = _this.getProviderDetails.bind((0,_assert_this_initialized/* default */.Z)(_this));
        return _this;
    }
    (0,_create_class/* default */.Z)(DetailsWithPrice, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.setState({
                    integratedLocationsHeight: 330,
                    productBoxWidth: this.productBox.current.offsetWidth,
                    productBoxHeight: this.productBox.current.offsetHeight
                });
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var ref, ref1, ref2, ref3, ref4, ref5;
                var _props = this.props, symbol = _props.symbol, addToWishlistClicked = _props.addToWishlistClicked, applicationLabel = _props.applicationLabel, applicationSlug = _props.applicationSlug, provider = _props.provider, addToCartClicked = _props.addToCartClicked, cartlist = _props.cartlist, externalrequest = _props.externalrequest, reviews = _props.reviews, geolocation = _props.geolocation, productIsLoading = _props.productIsLoading;
                var baseitem = this.props.item;
                var ref6 = (0,getProductServicesArray/* getProductServicesArray */.U)(baseitem, 0, provider, externalrequest), item = ref6.item, serviceArray = ref6.serviceArray, selectedServiceIndex = ref6.selectedServiceIndex, optionalServiceArray = ref6.optionalServiceArray;
                // Find the Index of the Service Array.. and then the Item .find(el => el.urlSlug === productId),
                // if provider <> 0 find in array and pop to front.
                item.applicationLabel = applicationLabel ? applicationLabel.trim() : "";
                item.ProductSpecifications = [];
                item.videoUrl = null;
                //  Add Return URL
                // If Service Array is Empty Disable Buy Now and Add to Cart Button.  ( Product is not available in your Area...)
                var productUrl = "/product/".concat(item.urlSlug);
                if (applicationSlug != undefined) {
                    productUrl = "".concat(productUrl, "/").concat(applicationSlug);
                }
                item.returnUrl = productUrl;
                var AppLabel = item.applicationLabel ? "Fits: " + item.applicationLabel : "";
                var msrp = Math.round(item.price * 1.15, 2);
                var providerMsrp = (item === null || item === void 0 ? void 0 : (ref = item.selectedProviderService) === null || ref === void 0 ? void 0 : ref.providerId) ? Math.round(item.selectedProviderService.providerId.Price * 1.15, 2) : undefined;
                // If any of servicas is available it means the product is available
                var hasAvailableServices = serviceArray.length > 0;
                // If the only service available is the priceOnly, a fake one.
                var hasOnlyPriceOnlyService = serviceArray.length === 1 && serviceArray[0].isShowPriceOnly;
                // geolocation.isLoading ? does it work?
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    ref: this.productBox,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "product-sidebar",
                        children: [
                            this.state.showProviderDetails && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProviderDetails/* default */.Z, {
                                onProductPage: true,
                                optionalServiceArray: optionalServiceArray,
                                show: this.state.showProviderDetails,
                                data: this.state.providerDetails,
                                width: this.state.productBoxWidth,
                                height: this.state.productBoxHeight * 1.5,
                                left: -this.state.productBoxWidth - 15,
                                close: function() {
                                    return _this.setState({
                                        showProviderDetails: false
                                    });
                                },
                                reviews: reviews
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "intro-container",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "text-container",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                            className: "sku",
                                            children: item.name
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "numbers-container",
                                        children: [
                                            productIsLoading && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "horizontal-loader",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(loader/* default */.Z, {})
                                            }),
                                            typeof item.selectedProviderService !== "undefined" && Object.keys(item.selectedProviderService).length !== 0 && !serviceArray[selectedServiceIndex].DisableCart || !hasAvailableServices ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "price",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "old-price",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("del", {
                                                                children: [
                                                                    "$",
                                                                    symbol,
                                                                    formatCurrency(providerMsrp || msrp)
                                                                ]
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: "15% off"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "valid-price",
                                                        children: [
                                                            symbol,
                                                            "$",
                                                            formatCurrency((item === null || item === void 0 ? void 0 : (ref1 = item.selectedProviderService) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.providerId) === null || ref2 === void 0 ? void 0 : ref2.Price) || item.price),
                                                            " "
                                                        ]
                                                    })
                                                ]
                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "price not-available",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "old-price",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "fas fa-info-circle"
                                                            }),
                                                            " Please call for Price"
                                                        ]
                                                    })
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("h2", {
                                className: "short-description",
                                children: [
                                    item.shortDescription,
                                    " ",
                                    applicationLabel && "for ".concat(applicationLabel)
                                ]
                            }),
                            this.props.renderTransferOverlay ? /*#__PURE__*/ (0,jsx_runtime.jsx)(UpsellOverlay, {
                                geolocation: geolocation,
                                urlSlug: (ref3 = this.props.item.category) === null || ref3 === void 0 ? void 0 : ref3.urlSlug
                            }) : hasAvailableServices ? hasOnlyPriceOnlyService ? /*#__PURE__*/ (0,jsx_runtime.jsx)(product_NotAvailable, {
                                categoryUrlSlug: (ref4 = item.category) === null || ref4 === void 0 ? void 0 : ref4.urlSlug,
                                geolocation: geolocation,
                                isLoading: productIsLoading
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(AddToCartSelector/* default */.Z, {
                                isLoading: productIsLoading,
                                cartlist: cartlist,
                                optionalServiceArray: optionalServiceArray,
                                serviceArray: serviceArray,
                                selectedServiceIndex: selectedServiceIndex,
                                item: item,
                                addToWishlistClicked: addToWishlistClicked,
                                addToCartClicked: addToCartClicked,
                                setSelectedProvider: this.props.setSelectedProvider,
                                showProviderDetails: function() {
                                    return _this.getProviderDetails();
                                },
                                provider: provider,
                                forceState: this.forceState,
                                showReviews: this.props.showReviews,
                                reviews: reviews,
                                showFitment: this.props.showFitment
                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(product_NotAvailable, {
                                categoryUrlSlug: (ref5 = item.category) === null || ref5 === void 0 ? void 0 : ref5.urlSlug,
                                geolocation: geolocation,
                                isLoading: productIsLoading
                            })
                        ]
                    })
                });
            }
        }
    ]);
    return DetailsWithPrice;
}(react.Component);
/* harmony default export */ var details_price = (DetailsWithPrice);

// EXTERNAL MODULE: ./src/utils/index.js + 7 modules
var utils = __webpack_require__(2277);
// EXTERNAL MODULE: ./node_modules/react-tabs/esm/index.js + 11 modules
var esm = __webpack_require__(19723);
;// CONCATENATED MODULE: ./src/components/product/details-top-tabs.jsx








var DetailsTopTabs = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(DetailsTopTabs, Component);
    var _super = (0,_create_super/* default */.Z)(DetailsTopTabs);
    function DetailsTopTabs() {
        (0,_class_call_check/* default */.Z)(this, DetailsTopTabs);
        var _this;
        _this = _super.call(this);
        _this.state = {
            open: false,
            nav1: null,
            nav2: null
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(DetailsTopTabs, [
        {
            key: "render",
            value: function render() {
                var ref, ref1, ref2;
                var item = this.props.item;
                var hasDescription = item.fullDescription || item.shortDescription;
                return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                    className: "tab-product mt-0",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "row",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "col-sm-12 col-lg-12",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Tabs */.mQ, {
                                className: "tab-content nav-material table-responsive",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* TabList */.td, {
                                        className: "nav nav-tabs nav-material",
                                        children: [
                                            item.brand ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Tab */.OK, {
                                                className: "nav-item",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "nav-link",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "icofont icofont-ui-home"
                                                            }),
                                                            "Brand Details"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "material-border"
                                                    })
                                                ]
                                            }) : "",
                                            (item === null || item === void 0 ? void 0 : (ref = item.productSpecifications) === null || ref === void 0 ? void 0 : ref.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Tab */.OK, {
                                                className: "nav-item",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "nav-link",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "icofont icofont-ui-home"
                                                            }),
                                                            "Specifications"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "material-border"
                                                    })
                                                ]
                                            }),
                                            hasDescription && /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Tab */.OK, {
                                                className: "nav-item",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "nav-link",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "icofont icofont-man-in-glasses"
                                                            }),
                                                            "Description"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "material-border"
                                                    })
                                                ]
                                            }),
                                            item.videoUrl && /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* Tab */.OK, {
                                                className: "nav-item",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "nav-link",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                className: "icofont icofont-contacts"
                                                            }),
                                                            "Video"
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "material-border"
                                                    })
                                                ]
                                            })
                                        ]
                                    }),
                                    item.brand && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TabPanel */.x4, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "brand-description",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    target: "_blank",
                                                    rel: "noopener noreferrer",
                                                    href: item.brand.website,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        src: item.brand.imageUrl,
                                                        alt: "brandimage"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                    children: item.brand.longDescription ? item.brand.longDescription : ""
                                                })
                                            ]
                                        })
                                    }),
                                    (item === null || item === void 0 ? void 0 : (ref1 = item.productSpecifications) === null || ref1 === void 0 ? void 0 : ref1.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TabPanel */.x4, {
                                        className: "tab-pane fade show active",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("table", {
                                            className: "table",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("tbody", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                children: "Specification"
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                children: "Value"
                                                            })
                                                        ]
                                                    }, "header"),
                                                    item === null || item === void 0 ? void 0 : (ref2 = item.productSpecifications) === null || ref2 === void 0 ? void 0 : ref2.map(function(spec, i) {
                                                        return /*#__PURE__*/ (0,jsx_runtime.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("th", {
                                                                    children: spec.specificationAttribute.name
                                                                }),
                                                                spec.specificationValue.startsWith("http") ? /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                                        href: spec.specificationValue,
                                                                        target: "_blank",
                                                                        rel: "noreferrer",
                                                                        children: [
                                                                            "View ",
                                                                            spec.specificationAttribute.name
                                                                        ]
                                                                    })
                                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("td", {
                                                                    children: spec.specificationValue
                                                                })
                                                            ]
                                                        }, i);
                                                    })
                                                ]
                                            })
                                        })
                                    }),
                                    hasDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TabPanel */.x4, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "description",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                children: (0,utils/* markdownify */.gI)(item.fullDescription ? item.fullDescription : item.shortDescription)
                                            })
                                        })
                                    }),
                                    item.videoUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* TabPanel */.x4, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "mt-4 text-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: "embed-responsive embed-responsive-16by9",
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("iframe", {
                                                    title: "Video for Product " + item.name,
                                                    src: item.videoUrl,
                                                    allow: "autoplay; encrypted-media" // TODO: setup Iframe tp autoplay on focus...
                                                    ,
                                                    allowFullScreen: true
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    })
                });
            }
        }
    ]);
    return DetailsTopTabs;
}(react.Component);
/* harmony default export */ var details_top_tabs = (DetailsTopTabs);

;// CONCATENATED MODULE: ./src/components/product/Gallery.jsx







var Gallery = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Gallery, Component);
    var _super = (0,_create_super/* default */.Z)(Gallery);
    function Gallery(props) {
        (0,_class_call_check/* default */.Z)(this, Gallery);
        var _this;
        _this = _super.call(this, props);
        _this.state = {
            activeIndex: 0
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(Gallery, [
        {
            key: "render",
            value: function render() {
                var _this = this;
                var images = this.props.images;
                var activeIndex = this.state.activeIndex;
                var image = images.length > 0 ? images[activeIndex].imageUrl : __webpack_require__(16776);
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "gallery",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "preview-container",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "preview-wrapper",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "preview",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        objectFit: "contain",
                                        layout: "fill",
                                        src: image,
                                        alt: "Item Picture"
                                    })
                                })
                            })
                        }),
                        images.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "selection-container",
                            children: images.map(function(item, index) {
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "selection-item position-relative ".concat(activeIndex === index ? "active" : ""),
                                    onClick: function() {
                                        return _this.setState({
                                            activeIndex: index
                                        });
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                        layout: "fill",
                                        objectFit: "contain",
                                        src: item.imageUrl,
                                        alt: "Item Picture"
                                    })
                                }, index);
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return Gallery;
}(react.Component);
/* harmony default export */ var product_Gallery = (Gallery);

// EXTERNAL MODULE: ./node_modules/react-tooltip/dist/index.es.js + 3 modules
var index_es = __webpack_require__(24762);
;// CONCATENATED MODULE: ./src/components/product/related-products.jsx






var related_products_formatCurrency = __webpack_require__(9180);




var RelatedProduct = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(RelatedProduct, Component);
    var _super = (0,_create_super/* default */.Z)(RelatedProduct);
    function RelatedProduct() {
        (0,_class_call_check/* default */.Z)(this, RelatedProduct);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(RelatedProduct, [
        {
            key: "render",
            value: function render() {
                var _props = this.props, productList = _props.productList, applicationSlug = _props.applicationSlug, provider = _props.provider, externalrequest = _props.externalrequest;
                if ((productList ? productList.length : 0) == 0) {
                    return "";
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "related-products-container",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                            className: "section-title",
                            children: "Related Products"
                        }),
                        productList.map(function(item, i) {
                            var productUrl = "/product/".concat(item.urlSlug);
                            var hrefUrl = "/product/[productid]";
                            if (applicationSlug != undefined) {
                                productUrl = "".concat(productUrl, "/").concat(applicationSlug);
                                hrefUrl = "".concat(hrefUrl, "/[crossreferenceid]");
                            }
                            // If more services than 0, it means the product is available
                            var hasServices = (0,getProductServicesArray/* getProductServicesArray */.U)(item, 0, provider, externalrequest).serviceArray.length > 0;
                            var imageUrl = item ? (item === null || item === void 0 ? void 0 : item.productPictures.length) > 0 ? item.productPictures[0].imageUrl : null : null;
                            // Render related product only if available
                            return hasServices ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "product-item",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                    href: hrefUrl,
                                    as: productUrl,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "body",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "img-container position-relative",
                                                    style: {
                                                        width: "64px",
                                                        height: "50px"
                                                    },
                                                    children: imageUrl && /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                        objectFit: "contain",
                                                        layout: "fill",
                                                        src: imageUrl,
                                                        className: "lazyload",
                                                        alt: "item"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "content-container",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "primary",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "title",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                            children: item.name
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                            children: item.shortDescription
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "price",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h5", {
                                                                            children: [
                                                                                "$",
                                                                                related_products_formatCurrency(item.price)
                                                                            ]
                                                                        }),
                                                                        item.groupMessage && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "indicator ",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "graphic",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                            style: {
                                                                                                left: item.groupMessage === "Ultimate" ? "85%" : item.groupMessage === "Best" ? "70%" : item.groupMessage === "Better" ? "50%" : item.groupMessage === "Good" ? "30%" : item.groupMessage === "Lowest" ? "10%" : "85%"
                                                                                            },
                                                                                            className: "fas fa-triangle"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "square",
                                                                                            style: {
                                                                                                left: item.groupMessage === "Ultimate" ? "90%" : item.groupMessage === "Best" ? "80%" : item.groupMessage === "Better" ? "70%" : item.groupMessage === "Good" ? "60%" : item.groupMessage === "Lowest" ? "50%" : "85%"
                                                                                            }
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                    children: item.groupMessage ? item.groupMessage : ""
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "cta-buttons",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "info-available",
                                                                children: "Available"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    })
                                })
                            }, i) : null;
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(index_es/* default */.Z, {})
                    ]
                });
            }
        }
    ]);
    return RelatedProduct;
}(react.Component);
/* harmony default export */ var related_products = (RelatedProduct);

// EXTERNAL MODULE: ./src/services/index.js
var services = __webpack_require__(59327);
;// CONCATENATED MODULE: ./src/components/product/service-new.jsx







//TODO:   Use NEW ETA Logic..
function DeliveryMinutes(location) {
    var DeliveryMessage = "";
    var leadTime = location.LeadTimeMinutes ? location.LeadTimeMinutes : 60;
    var deliveryMinutes = leadTime + Math.ceil(location.DistanceMiles);
    if (deliveryMinutes > 0) {
        DeliveryMessage = "est. ".concat(deliveryMinutes, " min*");
    }
    return DeliveryMessage;
}
var Service = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Service, Component);
    var _super = (0,_create_super/* default */.Z)(Service);
    function Service() {
        (0,_class_call_check/* default */.Z)(this, Service);
        return _super.apply(this, arguments);
    }
    (0,_create_class/* default */.Z)(Service, [
        {
            key: "render",
            value: function render() {
                var _item = this.props.item, installLocations = _item.installLocations, shippingLocations = _item.shippingLocations, roadsideLocations = _item.roadsideLocations, deliveryLocations = _item.deliveryLocations, pickupLocations = _item.pickupLocations;
                if (!installLocations) {
                    installLocations = [];
                }
                if (!shippingLocations) {
                    shippingLocations = [];
                }
                if (!roadsideLocations) {
                    roadsideLocations = [];
                }
                if (!deliveryLocations) {
                    deliveryLocations = [];
                }
                if (!pickupLocations) {
                    pickupLocations = [];
                }
                var providerLocation = this.props.providerLocation;
                var open_now = false;
                var city = "";
                if (providerLocation && providerLocation.location) {
                    if (providerLocation.location.googlePlacesData) {
                        if (providerLocation.location.googlePlacesData.result) {
                            open_now = providerLocation.location.googlePlacesData.result.opening_hours.open_now;
                        }
                    }
                    if (providerLocation.location.address) {
                        city = providerLocation.location.address.city;
                    }
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "services-container mb-3",
                    children: [
                        providerLocation && providerLocation.location && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "service-item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "image",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fas fa-store-alt"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "content",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h6", {
                                            children: [
                                                "Welcome to Store# ",
                                                providerLocation.location.id
                                            ]
                                        }),
                                        open_now && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    "Open Now ",
                                                    " in ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "clickable",
                                                        children: city
                                                    })
                                                ]
                                            })
                                        }),
                                        !open_now && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                children: [
                                                    "Open Tomorrow",
                                                    " in ",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "clickable",
                                                        children: city
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        }),
                        installLocations && installLocations.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "service-item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "image",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fas fa-tools"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "content",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                            children: "Installation Available"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        "We are ",
                                                        (0,services/* getDistanceMessage */.$h)(installLocations[0].DistanceMiles)
                                                    ]
                                                }),
                                                " in",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "clickable",
                                                    children: [
                                                        installLocations[0].City,
                                                        ", ",
                                                        installLocations[0].State
                                                    ]
                                                }),
                                                "."
                                            ]
                                        }),
                                        installLocations && installLocations.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "mt-2",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "far fa-info-circle"
                                                }),
                                                " ",
                                                installLocations.length - 1,
                                                " other Locations Available"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        pickupLocations && pickupLocations.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "service-item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "image",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fas fa-tools"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "content",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                            children: "Pickup Available"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    children: [
                                                        "We are ",
                                                        (0,services/* getDistanceMessage */.$h)(pickupLocations[0].DistanceMiles)
                                                    ]
                                                }),
                                                " in",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                    className: "clickable",
                                                    children: [
                                                        pickupLocations[0].City,
                                                        ", ",
                                                        pickupLocations[0].State
                                                    ]
                                                }),
                                                "."
                                            ]
                                        }),
                                        pickupLocations && pickupLocations.length > 1 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                    className: "far fa-info-circle"
                                                }),
                                                " ",
                                                pickupLocations.length - 1,
                                                " other Locations Available"
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        (installLocations.length > 0 || pickupLocations.length > 0) && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "service-item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "image",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fas fa-calendar-day"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "content",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                        children: "Same Day"
                                    })
                                })
                            ]
                        }),
                        shippingLocations.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "service-item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "image",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fas fa-shipping-fast"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "content",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                            children: "Fast Shipping"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            children: [
                                                "From:",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "clickable",
                                                    children: "".concat(shippingLocations[0].City, ", ").concat(shippingLocations[0].State)
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        }),
                        deliveryLocations.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "service-item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "image",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fas fa-shipping-fast"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "content",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                            children: "Delivery Available"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: DeliveryMinutes(deliveryLocations[0])
                                        })
                                    ]
                                })
                            ]
                        }),
                        roadsideLocations.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "service-item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "image",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fas fa-tools"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "content",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                            children: "Roadside Service Available"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "Be careful and stay in your car in a seatbelt."
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "service-item",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "image",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                        className: "fas fa-user-lock"
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "content",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                            children: "Safe and Secure"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            children: "We keep your data private."
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                });
            }
        }
    ]);
    return Service;
}(react.Component);
/* harmony default export */ var service_new = (Service);

;// CONCATENATED MODULE: ./src/components/product/product.jsx


























var bio = null;
var Product = /*#__PURE__*/ function(Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Product, Component);
    var _super = (0,_create_super/* default */.Z)(Product);
    function Product(props) {
        (0,_class_call_check/* default */.Z)(this, Product);
        var _this;
        _this = _super.call(this, props);
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "onOpenModal", function() {
            _this.setState({
                modalTermsOfServiceOpen: true
            });
        });
        (0,_define_property/* default */.Z)((0,_assert_this_initialized/* default */.Z)(_this), "onCloseModal", function() {
            _this.setState({
                modalTermsOfServiceOpen: false
            });
        });
        _this.state = {
            modalTermsOfServiceOpen: false,
            termsOfServiceContent: "",
            bio: null,
            showUpsellOverlay: false,
            showVideoModal: false
        };
        return _this;
    }
    (0,_create_class/* default */.Z)(Product, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this = this;
                var item = this.props.item;
                if (item) {
                    var trackItem = {
                        product_id: item.bigCommerceId,
                        sku: item.sku,
                        name: item.name,
                        price: item.price,
                        category: item.categoryId,
                        brand: item.brandId
                    };
                    bio = item ? item.selectedProviderService ? item.selectedProviderService.providerId : null : null;
                    this.setState({
                        bio: bio
                    });
                    analytics.track("Product Viewed", trackItem);
                    window.addEventListener("load", function() {
                        var ref;
                        gbTracker.sendViewProductEvent({
                            product: {
                                productId: item.bigCommerceId,
                                title: item.name,
                                price: item.price,
                                category: ((ref = item.category) === null || ref === void 0 ? void 0 : ref.id) || 2,
                                sku: item.sku
                            }
                        });
                    });
                    if (this.props.renderTransferOverlay) {
                        setTimeout(function() {
                            _this.setState({
                                showUpsellOverlay: true
                            });
                        }, 2000);
                    }
                }
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps, prevState) {
                var item = this.props.item;
                if (prevProps.item !== this.props.item) {
                    bio = item ? item.selectedProviderService ? item.selectedProviderService.providerId : null : null;
                    this.setState({
                        bio: bio
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _props = this.props, symbol = _props.symbol, item = _props.item, addToCart = _props.addToCart, addToCartUnsafe = _props.addToCartUnsafe, addToWishlist = _props.addToWishlist, addToCompare = _props.addToCompare, crossreferenceid = _props.crossreferenceid, applicationLabel = _props.applicationLabel, category = _props.category, breadcrumbs = _props.breadcrumbs, provider = _props.provider, cartlist = _props.cartlist, reviews = _props.reviews, setSelectedProvider = _props.setSelectedProvider, providerLocation = _props.providerLocation, masterProvider = _props.masterProvider, geolocation = _props.geolocation, productIsLoading = _props.productIsLoading;
                var bio = this.state.bio;
                var applicationProducts = this.props.applicationProducts;
                if (applicationProducts != undefined && item != undefined) {
                    applicationProducts = applicationProducts.filter(function(applicationProducts) {
                        return applicationProducts.id != item.id;
                    });
                }
                return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "page product",
                    children: [
                        breadcrumbs.length > 0 && category ? /*#__PURE__*/ (0,jsx_runtime.jsx)(CategoryBreadCrumb/* default */.Z, {
                            category: category,
                            breadcrumbs: breadcrumbs
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(breadcrumb/* default */.Z, {
                            title: item.name
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "inner",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "container",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "row",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "col-xl-3 left-content services",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "related-products-wrapper",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(service_new, {
                                                        item: item
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(related_products, {
                                                        productList: applicationProducts,
                                                        applicationSlug: crossreferenceid,
                                                        addToCart: addToCartUnsafe,
                                                        addToCompare: addToCompare,
                                                        addToWishlist: addToWishlist
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "col-xl-9",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "row",
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "col-lg-7 col-md-6 col-12 center",
                                                            children: (item === null || item === void 0 ? void 0 : item.productPictures) && /*#__PURE__*/ (0,jsx_runtime.jsx)(product_Gallery, {
                                                                images: item.productPictures
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: "col-lg-5 col-md-6 col-12 right-sidebar",
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "discounts",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FeedbackModal/* default */.Z, {
                                                                            open: this.state.modalTermsOfServiceOpen,
                                                                            type: "info",
                                                                            title: "Terms of Service",
                                                                            content: this.state.termsOfServiceContent,
                                                                            onCloseModal: this.onCloseModal,
                                                                            confirmAction: this.onCloseModal,
                                                                            buttonConfirm: "OK"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CampaignBanner/* default */.Z, {
                                                                            campaigns: item.campaigns
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(details_price, {
                                                                    renderTransferOverlay: this.props.renderTransferOverlay,
                                                                    cartlist: cartlist,
                                                                    symbol: symbol,
                                                                    item: item,
                                                                    addToCartClicked: addToCart,
                                                                    BuynowClicked: addToCartUnsafe,
                                                                    addToWishlistClicked: addToWishlist,
                                                                    applicationLabel: applicationLabel,
                                                                    applicationSlug: crossreferenceid,
                                                                    setSelectedProvider: setSelectedProvider,
                                                                    provider: provider,
                                                                    geolocation: geolocation,
                                                                    productIsLoading: productIsLoading,
                                                                    showReviews: !masterProvider || masterProvider && !masterProvider.isActive,
                                                                    reviews: reviews,
                                                                    showFitment: true
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                !this.props.renderTransferOverlay && /*#__PURE__*/ (0,jsx_runtime.jsx)(Reviews["default"], {
                                                    type: "textBanner",
                                                    reviews: reviews
                                                }),
                                                this.props.renderTransferOverlay && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(VideoModal["default"], {
                                                            open: this.state.showVideoModal,
                                                            onCloseModal: function() {
                                                                return _this.setState({
                                                                    showVideoModal: false
                                                                });
                                                            }
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "banner-with-sample-report align-middle",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "inner",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "container",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "row",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "col-md-8 align-middle",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "text",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                                            children: "How the Process Works"
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                            children: "This is the easiest to use Battery platform in the world today, combining the best about DoorDash, Uber, and making the installation of batteries transparent and cheaper for you. From Prices to Delivery, we keep you informed and no hidden fees. If you have any questions we are always available. Please watch the 90 second video for more info."
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "col",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                    className: "image",
                                                                                    onClick: function() {
                                                                                        return _this.setState({
                                                                                            showVideoModal: true
                                                                                        });
                                                                                    },
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                                                                            width: "400px",
                                                                                            height: "229px",
                                                                                            src: video_thumbnail/* default */.Z,
                                                                                            alt: "Car Battery Installation Video",
                                                                                            className: "lazyload"
                                                                                        })
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "steps mb-2",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                className: "container",
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                    className: "inner",
                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                        className: "row",
                                                                        children: [
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "col",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                    href: "/category/".concat(item.category.urlSlug),
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: "item",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                className: "start-here",
                                                                                                children: "Start Here"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                src: landing_location/* default.src */.Z.src,
                                                                                                alt: "",
                                                                                                className: "lazyload"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                                                children: "Step 1"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                                                children: "Provide your Information"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                children: "We will provide an immediate price quote based on your vehicle model and location."
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "col",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                    href: "/category/".concat(item.category.urlSlug),
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: "item",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                src: choose/* default.src */.Z.src,
                                                                                                alt: "",
                                                                                                className: "lazyload"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                                                children: "Step 2"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                                                children: "Select your Service Option"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                                children: [
                                                                                                    "We offer",
                                                                                                    " ",
                                                                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                                                        children: "Pickup, Delivery and Installation"
                                                                                                    }),
                                                                                                    " ",
                                                                                                    "options."
                                                                                                ]
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            }),
                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                className: "col",
                                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                                                                    href: "/category/".concat(item.category.urlSlug),
                                                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                        className: "item no-affirm-disclaimer-border",
                                                                                        children: [
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                                                src: hot_cup/* default.src */.Z.src,
                                                                                                alt: "",
                                                                                                className: "lazyload"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h4", {
                                                                                                children: "Step 3"
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("h6", {
                                                                                                children: "Place your order and we do the rest."
                                                                                            }),
                                                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                children: "If you choose Delivery we’ll come to you. If you choose a Store our Technicians will be waiting for you."
                                                                                            })
                                                                                        ]
                                                                                    })
                                                                                })
                                                                            })
                                                                        ]
                                                                    })
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: "bottom-container",
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                    className: "bottom",
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "tagline-container",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                                    children: "About Us"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                    className: "tagline",
                                                                                    children: [
                                                                                        "We are the ",
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                            children: "largest Battery Marketplace"
                                                                                        }),
                                                                                        " in North America. Over ",
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                            children: "10,000"
                                                                                        }),
                                                                                        " products,",
                                                                                        " ",
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                            children: "250,000"
                                                                                        }),
                                                                                        " locations, and",
                                                                                        " ",
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("strong", {
                                                                                            children: "1,000,000 "
                                                                                        }),
                                                                                        " needs served."
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                            className: "items-container",
                                                                            children: [
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                                                    children: "Our Services"
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "item",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "img",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                                className: "fas fa-shipping-fast",
                                                                                                "aria-hidden": "true"
                                                                                            })
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: "text",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                                    children: "FAST DELIVERY"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    children: "Most orders are 90 minutes or Less"
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "item",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "img",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                                className: "fas fa-calendar-check",
                                                                                                "aria-hidden": "true"
                                                                                            })
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: "text",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                                    className: "",
                                                                                                    children: "Make an Appointment"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                                                                    className: "",
                                                                                                    children: "Not an Emergency, schedule an appointment at your around your busy schedule."
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                }),
                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                    className: "item",
                                                                                    children: [
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                                            className: "img",
                                                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("i", {
                                                                                                className: "fas fa-wrench",
                                                                                                "aria-hidden": "true"
                                                                                            })
                                                                                        }),
                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                                                            className: "text",
                                                                                            children: [
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h5", {
                                                                                                    className: "",
                                                                                                    children: "PROFESSIONAL INSTALLATION!"
                                                                                                }),
                                                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                                                                    className: "",
                                                                                                    children: [
                                                                                                        "We Test Electrical, Install New Battery, Test Again and Recycle old Battery",
                                                                                                        " ",
                                                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("small", {
                                                                                                            children: "(Computer Resets too)"
                                                                                                        })
                                                                                                    ]
                                                                                                })
                                                                                            ]
                                                                                        })
                                                                                    ]
                                                                                })
                                                                            ]
                                                                        })
                                                                    ]
                                                                })
                                                            })
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "row",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "col-12",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(details_top_tabs, {
                                                                item: item
                                                            }),
                                                            bio && bio.ShowBio ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Bio/* default */.Z, {
                                                                showFitmentDisclaimer: false,
                                                                imageUrl: bio.DriverImageUrl,
                                                                name: bio.Name,
                                                                quote: bio.DriverBio
                                                            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {})
                                                        ]
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: "row",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "col-xl-12 bottom-content services",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(service_new, {
                                                                item: item,
                                                                providerLocation: providerLocation
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(related_products, {
                                                                productList: applicationProducts,
                                                                applicationSlug: crossreferenceid,
                                                                addToCart: addToCartUnsafe,
                                                                addToCompare: addToCompare,
                                                                addToWishlist: addToWishlist
                                                            })
                                                        ]
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                });
            }
        }
    ]);
    return Product;
}(react.Component);
/* harmony default export */ var product = (Product);


/***/ }),

/***/ 2277:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "rU": function() { return /* reexport */ utils_link; },
  "xf": function() { return /* reexport */ CategoryUrl; },
  "AK": function() { return /* reexport */ ClassNames; },
  "vn": function() { return /* reexport */ HtmlToReact; },
  "gI": function() { return /* reexport */ Markdownify; },
  "o2": function() { return /* reexport */ PostUrl; },
  "JF": function() { return /* reexport */ SafePrefix; }
});

// UNUSED EXPORTS: withPrefix

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
;// CONCATENATED MODULE: ./src/utils/classNames.js


// TODO: why do we need this? (V.T. 20.12.2021)
function ClassNames() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _classNames;
    return (_classNames = (classnames_default())).call.apply(_classNames, [
        this
    ].concat((0,_to_consumable_array/* default */.Z)(args))) || null;
}

// EXTERNAL MODULE: ./node_modules/lodash/isEmpty.js
var isEmpty = __webpack_require__(41609);
var isEmpty_default = /*#__PURE__*/__webpack_require__.n(isEmpty);
// EXTERNAL MODULE: ./node_modules/react-html-parser/lib/index.js
var lib = __webpack_require__(30653);
;// CONCATENATED MODULE: ./src/utils/htmlToReact.js


// TODO: why do we need this? (V.T. 20.12.2021)
function HtmlToReact(html) {
    if (!html) {
        return null;
    }
    return (0,lib/* default */.ZP)(html, {
        transform: function(node) {
            if (node.type === "script") {
                if (!isEmpty_default()(node.children)) {
                    return "";
                } else {
                    return "";
                }
            }
        }
    });
}

// EXTERNAL MODULE: ./node_modules/marked/lib/marked.esm.js
var marked_esm = __webpack_require__(87441);
;// CONCATENATED MODULE: ./src/utils/markdownify.js


function Markdownify(markdown) {
    if (!markdown) {
        return null;
    }
    return HtmlToReact(marked_esm/* marked.parse */.TU.parse(markdown));
}

// EXTERNAL MODULE: ./node_modules/lodash/startsWith.js
var startsWith = __webpack_require__(10240);
var startsWith_default = /*#__PURE__*/__webpack_require__.n(startsWith);
;// CONCATENATED MODULE: ./src/utils/safePrefix.js

var withPrefix = (__webpack_require__(15629)/* ["default"] */ .Z);
function SafePrefix(url) {
    if (startsWith_default()(url, "#") || startsWith_default()(url, "http")) {
        return url;
    }
    return withPrefix(url);
}

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
;// CONCATENATED MODULE: ./src/utils/link.js






var Link = function(_param) {
    var children = _param.children, href = _param.href, other = (0,_object_without_properties/* default */.Z)(_param, [
        "children",
        "href"
    ]);
    // Pass Any internal link to Next.js Link, for anything else, use <a> tag
    var internal = /^\/(?!\/)/.test(href);
    // For root page, use index.js, for rest use [...slug].js
    var page = href === "/" ? "/" : "/[...slug]";
    var slug = href.split("/");
    if (slug.length > 2) {
        if (slug[1] == "category") {
            page = "/category/[categoryid]?categoryid=".concat(slug[2]);
        }
        if (slug[1] == "product") {
            page = "/product/[productid]?productid=".concat(slug[2]);
        }
    }
    if (internal) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
            href: page,
            as: href,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, other), {
                children: children
            }))
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("a", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        href: href
    }, other), {
        children: children
    }));
};
/* harmony default export */ var utils_link = (Link);

// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./node_modules/lodash/trim.js
var trim = __webpack_require__(92742);
var trim_default = /*#__PURE__*/__webpack_require__.n(trim);
;// CONCATENATED MODULE: ./src/utils/postUrl.js


var postUrl_withPrefix = (__webpack_require__(15629)/* ["default"] */ .Z);
function PostUrl(post) {
    var slug = trim_default()(get_default()(post, "slug"), "/");
    return postUrl_withPrefix("/blog/".concat(slug));
}

;// CONCATENATED MODULE: ./src/utils/categoryUrl.js


var categoryUrl_withPrefix = (__webpack_require__(15629)/* ["default"] */ .Z);
// TODO: Generalize function and reuse (V.T. 31.1.2022)
function CategoryUrl(category) {
    var slug = trim_default()(get_default()(category, "slug"), "/");
    return categoryUrl_withPrefix("/blog/category/".concat(slug));
}

// EXTERNAL MODULE: ./src/utils/withPrefix.js
var utils_withPrefix = __webpack_require__(15629);
;// CONCATENATED MODULE: ./src/utils/index.js










/***/ }),

/***/ 15629:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ WithPrefix; }
/* harmony export */ });
/* harmony import */ var lodash_trimStart__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(98392);
/* harmony import */ var lodash_trimStart__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(lodash_trimStart__WEBPACK_IMPORTED_MODULE_0__);

function WithPrefix(url) {
    var basePath = "";
    return basePath + "/" + lodash_trimStart__WEBPACK_IMPORTED_MODULE_0___default()(url, "/");
}


/***/ }),

/***/ 50247:
/***/ (function() {

/* (ignored) */

/***/ })

}]);